import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

/** Stable JSON key for React Query when filters is a plain object (key order–independent). */
function stableFilterKey(filters?: Record<string, string | number | undefined>): string {
    if (!filters) return '';
    const keys = Object.keys(filters).sort();
    const normalized: Record<string, string | number | undefined> = {};
    for (const k of keys) {
        normalized[k] = filters[k];
    }
    return JSON.stringify(normalized);
}

export function useEntityList(
    entityType: string,
    appSlug?: string,
    filters?: Record<string, string | number | undefined>,
) {
    const basePath = appSlug ? `/applications/${appSlug}/${entityType}` : `/${entityType}`;

    return useQuery({
        queryKey: [entityType, appSlug, stableFilterKey(filters)],
        queryFn: () => api.get(basePath, { params: filters }).then((r) => r.data),
    });
}

export function useCapabilityList(
    appKey?: string,
    filters?: Record<string, string | number | undefined>,
) {
    const basePath = appKey
        ? `/applications/${appKey}/capabilities`
        : `/capabilities`;

    const mergedFilters = { include_entitled: 'true', ...filters };

    return useQuery({
        queryKey: ['capabilities', appKey, stableFilterKey(mergedFilters)],
        queryFn: () => api.get(basePath, { params: mergedFilters }).then((r) => r.data),
    });
}

export function useApplications(filters?: Record<string, string | number | undefined>) {
    return useQuery({
        queryKey: ['applications', filters],
        queryFn: () => api.get('/applications', { params: filters }).then((r) => r.data),
    });
}
